export const colors = {
  white: '#FFFFFF',
  black: '#000000',
  dark: '#232323',
  grey: '#7c7c7c',
  primary: '#942985',
  secondary: '#8fbf45',
  blue: '#8FC1D4',
};
